<template>
    <b-card no-body class="card-notification">
      <router-link :to="parent + '/sub/' + link"  :class="type">
        <div class="left">
            <PuSkeleton circle :loading="isLoading" height="40px" width="40px">                
              <div class="icon" :class="type">
                <font-awesome-icon :icon="['fas', 'bullseye-arrow']"/>
              </div>
            </PuSkeleton>
        </div>

        <div class="right" :class="{isLoading : isLoading}">
          <h3>
              <PuSkeleton :loading="isLoading" :count="1" width='120px'>                
                {{title}}
              </PuSkeleton>              
          </h3>            
          <h4 class="secondTitle"  :class="type" v-if="subtitle">
            <PuSkeleton :loading="isLoading" :count="1">
              {{subtitle}}
            </PuSkeleton>
          </h4>
          <p class="desc">
            <PuSkeleton :loading="isLoading" :count="1">
              {{desc}}
            </PuSkeleton>
          </p>
        </div>

      </router-link>
    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardNotification",
  components:{ 
  },
  mixins: [card],
  props:{
    link:{
      type:String,
      default:'#',
    },
    parent:{
      type:String,
      default:'Parent',
    },
    title:{
      type:String,
      default:'Mon titre',
    },
    subtitle:{
      type:String,
    },
    desc:{
      type:String,
      default:'Affaire nouvelle DAB',
    },
    type:{
      type:String,
      default:'positif'
    }
  },
  data(){
    return {
        isLoading:true,
    }
  },
  methods : {
  },  
  mounted (){
    // this.getPourcentBetween(this.resultOne, this.resultTwo);
    // this.getNegatifOrNot(this.number);
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }   
}
</script>